"use client";

import * as PopoverPrimitive from "@radix-ui/react-popover";
import { FC, useState } from "react";

import { useGetUserFeatureFlag } from "@/features/common/hooks";
import { MediaQuery } from "@/shared/components";
import { Button } from "@/shared/ui";
import LeftArrowIcon from "@/svgs/angle_left_b.svg";
import ThreeDotsIcon from "@/svgs/ellipsis_h.svg";
import LogoIcon from "@/svgs/haute-societe.svg";
import { FeatureFlagEnum } from "@/types";

import styles from "./auth-header.module.scss";
import { AuthHeaderProps } from "./auth-header.types";
import { Popover } from "./popover";

const AuthHeader: FC<AuthHeaderProps> = ({ marginBottom = 32, hints = false, onClickBack }) => {
  const [isPopoverOpened, setIsPopoverOpened] = useState(false);

  useGetUserFeatureFlag(
    {
      name: FeatureFlagEnum.HIDDEN_DELETE_BUTTON,
    },
    hints
  );

  return (
    <header className={styles.container} style={{ marginBottom }}>
      <button className={styles.leftCol} onClick={onClickBack}>
        {onClickBack && <LeftArrowIcon className={styles.leftIcon} />}
      </button>

      <LogoIcon className={styles.logoIcon} />

      {hints ? (
        <PopoverPrimitive.Root open={isPopoverOpened} onOpenChange={(newValue) => setIsPopoverOpened(newValue)}>
          <PopoverPrimitive.Trigger className={styles.hints}>
            <ThreeDotsIcon />
          </PopoverPrimitive.Trigger>

          <PopoverPrimitive.Portal>
            <Popover onClose={() => setIsPopoverOpened(false)} />
          </PopoverPrimitive.Portal>
        </PopoverPrimitive.Root>
      ) : (
        <div />
      )}

      <MediaQuery.Laptop>
        {onClickBack && (
          <Button
            size="big"
            variant="outlined"
            icon={LeftArrowIcon}
            style={{ top: 32 + marginBottom + 4 }} // added +4 due to large line-height
            className={styles.leftArrowButton}
            onClick={onClickBack}
          >
            Back
          </Button>
        )}
      </MediaQuery.Laptop>
    </header>
  );
};

export { AuthHeader };
